// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"48":"ff5558c99f8c71d7","492":"9eea95735ea9f3b8","860":"cf778108346f3acc","902":"b291409a75bb91a1","978":"61fef7f7f83e415f"}[chunkId] + ".js";
};